import apis from "../../../../api";
import { errorTypes } from "../../../../utils/errorTypes";
import loaders from "../../actionCreators/loadersActionCreator";
import { setErrorHandler } from "../errorActionHandler";

export const getManageCertificatesActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setUsersData,
    setTempUsersData,
    setTotalRows
  ) =>
    async () => {
      await apis.admin.certificateManagement
        .getManageCertificates(searchText, pageNumber, pageSize)
        .then((response) => {
          setUsersData((prevStateData) => [
            ...prevStateData,
            ...response?.data?.Content,
          ]);
          setTempUsersData((prevStateData) => [
            ...prevStateData,
            ...response?.data?.Content,
          ]);
          setTotalRows(response?.data?.TotalRows);
        })
        .catch((err) => {
          console.log(err);
        });
    };

export const deleteCertificateActionHandler =
  (certificateId) => async (dispatch) => {
    dispatch(loaders.admin.certificateManagement.deleteCertificateLoader(true));
    return await apis.admin.certificateManagement
      .deleteCertificate(certificateId)
      .then((response) => {
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            "Certificate has been deleted successfully."
          )
        );
        return response;
      })
      .catch((err) => {
        if (err.response.status === 405) {
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "The certificate is already achieved by users and hence cannot be deleted."
            )
          );
        }
        console.log(err);
      })
      .finally(() => {
        dispatch(
          loaders.admin.certificateManagement.deleteCertificateLoader(false)
        );
      });
  };

export const uploadCertificateActionHandler =
  (fileName, data) => async (dispatch) => {
    // dispatch(loaders.admin.certificateManagement.uploadCertificateLoader(true));
    const formData = new FormData();
    formData.append("file", data);
    return await apis.admin.certificateManagement
      .uploadCertificate(fileName, formData)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      });
    // .finally(() => {
    //   dispatch(
    //     loaders.admin.certificateManagement.uploadCertificateLoader(false)
    //   );
    // });
  };
export const postNewCertificateActionHandler = (data) => async (dispatch) => {
  // dispatch(loaders.admin.certificateManagement.postNewCertificateLoader(true));
  return await apis.admin.certificateManagement
    .postNewCertificate(data)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch((err) => {
      console.log(err);
    });
  // .finally(() => {
  //   dispatch(
  //     loaders.admin.certificateManagement.postNewCertificateLoader(false)
  //   );
  // });
};

export const postEditCertificateActionHandler = (data) => async (dispatch) => {
  // dispatch(loaders.admin.certificateManagement.postEditCertificateLoader(true));
  return await apis.admin.certificateManagement
    .postEditCertificate(data)
    .then((response) => {
      if (response.data === 1) {
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            `Certificate has been edited successfully.`
          )
        );
      } else if (response.data === 0) {
        dispatch(
          setErrorHandler(
            errorTypes.FAIL,
            `The certificate cannot be updated as it is already attached to a Shotclass / Program.`
          )
        );
      }
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
  // .finally(() => {
  //   dispatch(
  //     loaders.admin.certificateManagement.postEditCertificateLoader(false)
  //   );
  // });
};
